//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DefaultTable from "@/components/objects/public/shared-blocks/tables/design-variant/Default.vue";
import RadiusTable from "@/components/objects/public/shared-blocks/tables/design-variant/Radius.vue";
import LineTable from "@/components/objects/public/shared-blocks/tables/design-variant/Line.vue";
import TheEcharts from "@/components/TheEcharts.vue";
import { v4 as uuidv4 } from 'uuid';
import { DesignExtra } from "@/utils/dto/objects.js";
import isEmpty from "lodash/isEmpty.js";
import { getDefaultThemeSettings } from "@/constants/ui.js"

export default {
  name: "Tables",
  components: { TheEcharts },
  provide: {
    source: 'objTables',
    module: 'tables'
  },
  props: {
    table: {
      type: Object,
      default: () => null
    },
    objectLabel: {
      type: String,
      default: ''
    },
    // eslint-disable-next-line vue/prop-name-casing
    vistat_object: {
      type: String,
      default: ''
    },
    user: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    const safeTable = this.table || {};
    const design = safeTable.design || 'default';
    const ui = safeTable.ui_data || {};
    const defaultTheme = getDefaultThemeSettings(design, 'tables', this.$store)?.themes?.[0];
    return {
      currentDesign: design,
      currentTheme: ui.design_theme || defaultTheme?.theme,
      designExtra: isEmpty(safeTable.design_extra) ? new DesignExtra(defaultTheme) : safeTable.design_extra,
      currentTemplate: null,
    }
  },
  computed: {
    showMode() {
      return this.table?.ui_data?.show || 'all';
    },
    renderComponent() {
      switch (this.currentDesign) {
      case "radius":
        return RadiusTable
      case "line":
        return LineTable
      default:
        return DefaultTable
      }
    },
    listInfo() {
      return {
        label: this.table.label,
        vistat_object: this.vistat_object,
        object_label: this.objectLabel,
        id: uuidv4(),
      }
    },
    charts() {
      const data = this.table && this.table.data ? this.table.data : {}
      if (!Array.isArray(data.charts)) return []
      return data.charts.filter(chart => chart && !chart.is_deleted && chart.chart_type)
    }
  },
  methods: {
    handleTabChange() {
      this.$nextTick(() => {
        const el = this.$refs.tablesRoot;
        if (el && typeof window !== 'undefined') {
          const top = el.getBoundingClientRect().top + window.pageYOffset - 100;
          window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
        }
      });
    },
    onDesignChange(evt) {
      this.currentDesign = evt;
      this.designExtra = new DesignExtra(getDefaultThemeSettings(evt, 'tables', this.$store).themes[0]);
      this.currentTheme = getDefaultThemeSettings(evt, 'tables', this.$store).themes[0].theme;
    },
    onThemeChange(evt) {
      this.currentTheme = evt;
      this.designExtra = new DesignExtra(getDefaultThemeSettings(this.currentDesign, 'tables', this.$store).themes.find(el => el.theme === evt));
    },
    chartAxisKey(chart) {
      if (!chart || !chart.chart_axis) return null
      return typeof chart.chart_axis.key !== 'undefined' ? chart.chart_axis.key : null
    },
    chartAxisGroup(chart) {
      if (!chart || !chart.chart_axis) return null
      return typeof chart.chart_axis.group !== 'undefined' ? chart.chart_axis.group : null
    },
    chartAxisValues(chart) {
      if (!chart || !chart.chart_axis) return []
      return Array.isArray(chart.chart_axis.values) ? chart.chart_axis.values : []
    }
  }
}
